<template>
  <!-- Same anatomy as the card in HomePage's current layout, so the two
       layouts differ in arrangement, not in how an artwork looks. -->
  <router-link
    :to="`/art/${item.friendly_id || item.id}`"
    class="art-card w-full block no-underline transform hover:scale-105 transition-transform duration-200 focus:outline-none focus:ring-2 focus:ring-red-600"
    :class="{ 'is-hot': hot }"
    @mouseenter.native="$emit('hover', item)"
    @mouseleave.native="$emit('leave', item)"
  >
    <div class="art-card__box bg-white overflow-hidden border border-gray-200 h-full flex flex-col">
      <!-- 4:3 rather than the current card's fixed 12rem: that is what the
           fixed height amounts to at the current grid's width, and a ratio
           holds whether the list is two columns beside the map or four without. -->
      <div class="art-card__img w-full bg-gray-200 relative flex-shrink-0">
        <img v-if="photo" :src="photo" :alt="item.title" class="art-card__media object-cover" loading="lazy" />
        <div v-else class="art-card__media flex items-center justify-center text-gray-500">No Image</div>
      </div>
      <div class="p-4 text-left flex flex-col flex-grow">
        <h3 class="art-card__title font-display text-xl mb-1 leading-tight text-gray-900">{{ item.title }}</h3>
        <div class="text-xs text-gray-500">
          by
          <span class="text-red-600 font-semibold">{{ artists }}</span>
        </div>
        <!-- Always rendered so a card without city and year keeps its height. -->
        <div class="art-card__where text-xs text-gray-500 mt-1">
          {{ [item.city, item.year].filter(Boolean).join(" · ") }}
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
import { primaryPhotoUrl } from "../features/map/photos"

export default {
  name: "ArtCard",
  props: {
    item: { type: Object, required: true },
    // The matching pin is under the pointer.
    hot: { type: Boolean, default: false },
  },
  computed: {
    photo() {
      return primaryPhotoUrl(this.item)
    },
    artists() {
      const names = (this.item.artists || []).map(a => a.name).filter(Boolean)
      return names.length ? names.join(", ") : "Unknown"
    },
  },
}
</script>

<style scoped>
.art-card__img {
  aspect-ratio: 4 / 3;
}
/* Uniform rows: a title reserves two lines and clamps to two; the place line
   keeps its height even when empty. */
.art-card__title {
  min-height: 3.125rem; /* 2 x (1.25rem x 1.25 leading-tight) */
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.art-card__where {
  min-height: 1rem;
}
/* Out of flow on purpose: an aspect-ratio box still grows to fit its content,
   and a portrait original at 3024x4032 would stretch it past 4:3. Absolutely
   positioned, the media fills the box and the ratio alone sets the height. */
.art-card__media {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}
/* The hover border is the one thing the current card does not have: it is
   what the map talks back through. */
.art-card.is-hot .art-card__box {
  border-color: #12302e;
}
</style>
